<template>
    <!-- Rendered bare inside forms that lay out their own sections, e.g. WorkOrderSection. -->
    <component
        :is="bare ? 'div' : 'DashboardEditSection'"
        v-if="tagConfigs.length"
        class="EntityTagsSection"
        :class="{ bare }"
        :title="bare ? null : 'Tags'"
    >
        <h5 v-if="bare">Tags</h5>
        <div class="tagsGrid">
            <FormMultiSelect
                v-for="config in tagConfigs"
                :key="config.position"
                :label="config.name"
                :options="config.options"
                :value="selectedFor(config.position)"
                @input="handleTagChange(config.position, $event)"
            />
        </div>
    </component>
</template>


<script>
import { mapState } from 'vuex';
import DashboardEditSection from '@/components/DashboardEditSection';

export default {
    name: 'EntityTagsSection',

    components: { DashboardEditSection },

    props: {
        tags: { type: Object, default: () => ({}) },
        bare: { type: Boolean, default: false },
    },

    computed: {
        ...mapState('company', ['tagConfigs']),

        currentTags() {
            return this.tags || {};
        },
    },

    methods: {
        // Tags used to hold a single value per position. Coerce so an entity saved before
        // the multi-select migration still shows its selection.
        selectedFor(position) {
            const value = this.currentTags[position];

            if (Array.isArray(value)) return value;

            return value ? [value] : [];
        },

        handleTagChange(position, values) {
            const updated = { ...this.currentTags };

            // A fresh array, not the emitted one: createPatch only shallow copies tags, so
            // an array mutated in place would defeat its diff and never be sent.
            if (values.length) {
                updated[position] = [...values];
            } else {
                delete updated[position];
            }

            this.$emit('update:tags', updated);
        },
    },
};
</script>


<style lang="scss" scoped>
@import 'globals.scss';
.EntityTagsSection {
    .tagsGrid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0 $grid-gutter-width;
    }

    // Match the sibling sections of the form that supplies its own layout.
    &.bare {
        margin-bottom: 25px;

        h5 {
            margin-bottom: 10px;
            font-weight: 600;
        }
    }
}
</style>
